<template>
  <v-app id="inspire" class="bg-gradient">
    <v-app-bar flat color="transparent">
      <v-img
        :src="brandLogoNegative"
        contain
        max-height="40"
        class="mt-6"
      ></v-img>
    </v-app-bar>
    <v-container class="fill-height">
      <v-row align="center" justify="space-around">
        <v-col cols="12" md="12" lg="5" xl="5" class="mb-4 mb-sm-5 mb-lg-0">
          <h1
            class="text-md-h3 text-sm-h4 text-center text-md-left white--text font-weight-bold"
          >
            ¡Bienvenido a tu portal de Pronto Conductor!
          </h1>
          <div class="text-h6 text-center text-md-left white--text mt-6">
            <p class="text-h6">Aquí podrás:</p>
            <ul class="mt-4 text-h6">
              <li>
                Activar pagos automáticos a tu tarjeta de crédito/débito.
                <span
                  style="
                    color: var(--v-primary-darken1);
                    background: var(--v-warning-lighten5);
                    font-size: small;
                    padding: 2px;
                  "
                >
                  {{ '¡próximamente! '.toLocaleUpperCase() }}
                </span>
              </li>
              <li>Generar tu CLABE de pago con SPEI.</li>
            </ul>
            <p class="text-body font-weight-regular mt-6">
              Ingresa con el mismo correo y contraseña que utilizas en la
              aplicación.
            </p>
          </div>
        </v-col>
        <v-divider vertical dark></v-divider>
        <v-col cols="12" md="12" lg="5" xl="5">
          <p class="text-center text-h4 font-weight-medium white--text">
            Iniciar sesión
          </p>
          <v-card class="pa-3 mt-6" shaped outlined>
            <v-card-text>
              <base-error class="mb-4" :errors="error"></base-error>
              <v-form
                ref="loginForm"
                v-model="valid"
                lazy-validation
                @submit="submit"
              >
                <v-text-field
                  v-model="email"
                  :rules="rules.email"
                  label="Correo electrónico o teléfono"
                  name="email"
                  type="text"
                  outlined
                  rounded
                  validate-on-blur
                  :disabled="isLoading"
                />
                <v-text-field
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="rules.password"
                  @click:append="showPassword = !showPassword"
                  id="password"
                  label="Contraseña"
                  name="password"
                  outlined
                  rounded
                  validate-on-blur
                  :disabled="isLoading"
                />
                <v-btn
                  color="primary"
                  depressed
                  block
                  large
                  rounded
                  :loading="isLoading"
                  type="submit"                  :disabled="isLoading"
                  >Entrar</v-btn
                >
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { to } from '@/helpers';
import AppConfig from '@/constants/app-config';
import rules from '@/constants/input-validation';
import { SESSION_LOGIN } from '@/store/actions.type';
export default {

  data() {
    return {
      isLoading: true,
      rules,
      brandLogoNegative: AppConfig.brandLogoNegative,
      showPassword: false,
      email: '',
      password: '',
      valid: true,
      error: null
    }
  },
  methods: {
    async login(credentials) {
        this.isLoading = true
        this.error = null
        const [err] = await to(this.$store.dispatch(SESSION_LOGIN, credentials))
        if (err) {
          this.isLoading = false
          if (err.status === 409) {
            this.error = 'Credenciales incorrectas, revisa tus datos'
          }
          if (err.status === 404) {
            this.error = 'No existe un usuario con ese correo electrónico o teléfono'
          }
        } else {
          this.isLoading = false
          this.$router.push({ name: 'payments' })
        }
    },


    async submit(evt) {
      evt.preventDefault()
      if (this.validateForm()) {
        this.login({
          email_or_phone: this.email,
          password: this.password
        })
      }
    },
    validateForm() {
      return this.$refs.loginForm.validate()
    }
  },
  mounted() {
    const query = this.$route.query || {}
    const token =
      query.token ||
      new URLSearchParams(window.location.search).get('token');

    if (token) {
      this.login({ token })
    } else {
      this.isLoading = false
    }
  }
}
</script>
